import { ReactSVG } from 'react-svg';
import AnchorTop from '@web/utils/src/assets/icons/functions/arrow-top.svg';

interface FormScreenHeaderProps {
  handleStageChange: (e: any, direction: 'next' | 'previous') => void;
  title: string;
}

export const FormScreenHeader = (props: FormScreenHeaderProps) => {
  const { handleStageChange, title } = props;

  return (
    <div className="flex pl-1-0">
      <div
        className="-rotate-90 cursor-pointer"
        onClick={(e) => handleStageChange(e, 'previous')}
      >
        <ReactSVG src={AnchorTop} className="text-white" />
      </div>
      <p className="font-bd text-body1">{title}</p>
    </div>
  );
};

export default FormScreenHeader;
